var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame1233(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 31,
    viewBox: "0 0 45 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5H44.5V30.5H5C2.51472 30.5 0.5 28.4853 0.5 26V5C0.500001 2.51472 2.51472 0.5 5 0.5Z",
    fill: "#2C963D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5H44.5V30.5H5C2.51472 30.5 0.5 28.4853 0.5 26V5C0.500001 2.51472 2.51472 0.5 5 0.5Z",
    stroke: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 17.5H24.71L24.43 17.23C25.444 16.0541 26.0012 14.5527 26 13C26 11.7144 25.6188 10.4577 24.9046 9.3888C24.1903 8.31988 23.1752 7.48676 21.9874 6.99479C20.7997 6.50282 19.4928 6.37409 18.2319 6.6249C16.971 6.8757 15.8128 7.49477 14.9038 8.40381C13.9948 9.31285 13.3757 10.471 13.1249 11.7319C12.8741 12.9928 13.0028 14.2997 13.4948 15.4874C13.9868 16.6752 14.8199 17.6903 15.8888 18.4046C16.9577 19.1188 18.2144 19.5 19.5 19.5C21.11 19.5 22.59 18.91 23.73 17.93L24 18.21V19L29 23.99L30.49 22.5L25.5 17.5ZM19.5 17.5C17.01 17.5 15 15.49 15 13C15 10.51 17.01 8.5 19.5 8.5C21.99 8.5 24 10.51 24 13C24 15.49 21.99 17.5 19.5 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1233);
export default __webpack_public_path__ + "static/media/Frame 1233.fa85d59606cac9825b1cc7ff753dbf75.svg";
export { ForwardRef as ReactComponent };